import * as React from 'react';
import { observer } from 'mobx-react';
import { withTheme } from 'styled-components';
import { styled } from '../utils/styled';
import { propStyles } from '../utils/propStyles';
import { Theme } from '../models/Theme';

const EmptyStateWrapper = styled<any, any>(
    'div',
    'emptyStateWrapper',
    'emptyState'
)`
    ${propStyles};
`;

EmptyStateWrapper.defaultProps = {
    fontSize: 'inherit',
    fontFamily: 'inherit',
    fontWeight: 'bold',
    textAlign: 'center',
    padding: 'xl',
};

interface EmptyStateProps {
    theme?: Theme;
    text: string;
}

@observer
class EmptyState extends React.Component<EmptyStateProps> {
    render() {
        const { theme, children, ...props } = this.props;
        return (
            <EmptyStateWrapper {...props} {...theme.EmptyState}>
                {children}
            </EmptyStateWrapper>
        );
    }
}

export default withTheme(EmptyState);



// WEBPACK FOOTER //
// ./src/Components/EmptyState.tsx